import * as React from 'react'
import { ReactElement } from 'react'
import { useFormikContext } from 'formik'
import { FileMutationDto } from '../../../config/fileConfig'
import { useFileModule, WorkInProgressModuleDto } from '../../../hooks/module/useFileModule'
import { ModuleType } from '../../../context/GlobalContext'
import { FieldProps } from '@fluentui/react-field'
import { Field } from '@fluentui/react-components'
import FactorInput from './Insolvency/FactorInput'
import MoneyInput from '../../Input/MoneyInput'
import { CommitEventType } from '../../Input/FormattableNumberInput'
import { useTranslation } from 'react-i18next'

type WorkInProgressFieldProps = {
    styles: Record<'formRow', string>
    orientation: FieldProps['orientation']
}

export default function WorkInProgressFields({ styles, orientation }: WorkInProgressFieldProps): ReactElement {
    const { values, setFieldValue } = useFormikContext<FileMutationDto>()
    const {
        has: hasFileModule,
        fileModule,
        index: fileModuleIndex,
    } = useFileModule<WorkInProgressModuleDto>(ModuleType.WorkInProgress, values)
    const { t: translate } = useTranslation()

    if (!hasFileModule) {
        return <></>
    }

    return (
        <div className={styles.formRow}>
            <Field label={translate('file.edit.form.finance.workinprogress.percentage')} orientation={orientation}>
                <FactorInput
                    step={1}
                    precision={0}
                    displayFormat={'0'}
                    value={fileModule.percentage}
                    onChange={value => {
                        setFieldValue(`modules[${fileModuleIndex}.percentage]`, value)
                    }}
                />
            </Field>
            <Field label={translate('file.edit.form.finance.workinprogress.tariff')} orientation={orientation}>
                <MoneyInput
                    value={fileModule.maxPrice}
                    currency={values.currency}
                    onCommit={(eventType: CommitEventType, value: string) => {
                        if (eventType !== CommitEventType.OnLoad) {
                            setFieldValue(`modules[${fileModuleIndex}.maxPrice]`, value)
                        }
                    }}
                />
            </Field>
        </div>
    )
}
